import React from 'react';
import cx from 'classnames';
import { useHistory } from 'react-router-dom';
import { Switch, Route } from 'react-router-dom';
// creates a beautiful scrollbar
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import AdminNavbar from 'components/Navbars/AdminNavbar.js';
import Sidebar from 'components/Sidebar/Sidebar.js';

import routes from 'routes.js';

import styles from 'assets/jss/material-dashboard-pro-react/layouts/adminStyle.js';

var ps;

const useStyles = makeStyles(styles);

export default function Main(props) {
	const { ...rest } = props;
	const history = useHistory();
  
	// states and functions
	const [mobileOpen, setMobileOpen] = React.useState(false);
	const [miniActive, setMiniActive] = React.useState(false);
	const [image] = React.useState(require('assets/img/sidebar-2.jpg'));
	const [color] = React.useState('blue');
	const [bgColor] = React.useState('black');
	// const [hasImage, setHasImage] = React.useState(true);
	const [logo] = React.useState(require('assets/img/logo-white.svg'));
	// styles
	const classes = useStyles();
	const mainPanelClasses =
		classes.mainPanel +
		' ' +
		cx({
			[classes.mainPanelSidebarMini]: miniActive,
			[classes.mainPanelWithPerfectScrollbar]: navigator.platform.indexOf('Win') > -1,
		});
	// ref for main panel div
	const mainPanel = React.createRef();
	// effect instead of componentDidMount, componentDidUpdate and componentWillUnmount
	React.useEffect(() => {
		if (!window.sessionStorage.getItem('userId')) {
			history.push('/user/login');
		}
		if (navigator.platform.indexOf('Win') > -1) {
			ps = new PerfectScrollbar(mainPanel.current, {
				suppressScrollX: true,
				suppressScrollY: false,
			});
			document.body.style.overflow = 'hidden';
		}
		window.addEventListener('resize', resizeFunction);

		// Specify how to clean up after this effect:
		return function cleanup() {
			if (navigator.platform.indexOf('Win') > -1) {
				ps.destroy();
			}
			window.removeEventListener('resize', resizeFunction);
		};
	});
	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};
	const getRoutes = (routes) => {
		return routes.map((prop, key) => {
			if (prop.collapse) {
				return getRoutes(prop.views);
			}
			return (
				<Route path={prop.layout + prop.path} component={prop.component} key={key} />
			);
		});
	};
	const sidebarMinimize = () => {
		setMiniActive(!miniActive);
	};
	const resizeFunction = () => {
		if (window.innerWidth >= 960) {
			setMobileOpen(false);
		}
	};

	return (
		<div className={classes.wrapper}>
			<Sidebar
				routes={routes}
				logoText={'Factory Doctor'}
				handleDrawerToggle={handleDrawerToggle}
				open={mobileOpen}
				color={color}
				bgColor={bgColor}
				miniActive={miniActive}
				sidebarMinimize={sidebarMinimize.bind(this)}
				{...rest}
			/>
			<div className={mainPanelClasses} ref={mainPanel} id="mainPanel">
				<div className={classes.content}>
					<div className={classes.container}>
						<Switch>
							{getRoutes(routes)}
						</Switch>
					</div>
				</div>
			</div>
		</div>
	);
}